export const cameraMove = {
  start: ['121.494278', '31.22232'],
  end: ['121.507043', '31.264138']
}

export const fiveRoutePoint = [
  ['121.50709', '31.232342'],
  ['121.487612', '31.226219'],
  ['121.4442', '31.254823'],
  ['121.512674', '31.298841'],
  ['121.490284', '31.24591']
]

/**
 * 黄浦江数据
 */
export const randomPoint = [
  [121.492194, 31.223243],
  [121.493447, 31.225991],
  [121.490614, 31.228021],
  [121.493348, 31.230312],
  [121.494762, 31.227324], //初始点

  [121.499077, 31.238828],
  [121.499426, 31.241159],
  [121.500972, 31.23697],
  [121.503185, 31.240124], //中间

  [121.505603, 31.262155],
  [121.507822, 31.26076],
  [121.503254, 31.261694],
  [121.507355, 31.259496],
  [121.5096, 31.260547]
]

export const alarmPoint = [
  [121.493265, 31.224081],
  [121.501204, 31.238447],
  [121.503334, 31.251916],
  [121.508311, 31.263433]
]
